//use client"

import { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import { breadcrumbSchemaJson } from "../../utils/breadcrumbSchema"
import "./../TeamMembers/TeamMembers.css"
import axiosInstance from "../../api/axiosInstance"
import { getPreloadedData, PreloadedScript } from "../../utils/preloadedData"

function TeamMembers() {
  // Seeded from the prerendered snapshot so the first client render matches the static HTML.
  const [teamMembers, setTeamMembers] = useState(() => getPreloadedData("__PRELOADED_TEAM_PAGE__") || [])
  const [loading, setLoading] = useState(() => getPreloadedData("__PRELOADED_TEAM_PAGE__") === null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axiosInstance.get("api/team-members")
        setTeamMembers(response.data)
      } catch (err) {
        setError("Failed to fetch team members")
      } finally {
        setLoading(false)
      }
    }

    fetchTeamMembers()
  }, [])

  // Display loader while fetching data
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    )
  }

  if (error) {
    return <p>{error}</p>
  }

  // Split team members into featured (first 2) and regular (rest)
  const featuredMembers = teamMembers.slice(0, 2)
  const regularMembers = teamMembers.slice(2)

  return (
    <div className="main_div_TeamMembers">
      <PreloadedScript id="__PRELOADED_TEAM_PAGE__" data={teamMembers} />
      <Helmet>
        
        <title>Meet Our Team | 360 SynergyTech</title>
        <link rel="canonical" href="https://360synergytech.com/team" />

        <meta property="og:title" content="Meet Our Team | 360 SynergyTech" />
        <meta property="og:url" content="https://360synergytech.com/team" />
        <meta property="og:image" content="https://360synergytech.com/header111.jpg" />
        <meta property="og:description" content="Get to know the expert developers, engineers, and strategists behind 360 SynergyTech who drive innovation and deliver world-class digital solutions." />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Meet Our Team | 360 SynergyTech" />
        <meta name="twitter:description" content="Meet the people powering AI, cloud, and IT solutions at SynergyTech." />
        <meta name="twitter:image" content="https://360synergytech.com/header111.jpg" />
 
        
        <meta name="description" content="Meet the experts at 360 SynergyTech, dedicated to delivering innovative AI, cloud, web, and advanced technology solutions for your business" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "360 SynergyTech",
              "url": "https://360synergytech.com/team",
              "employee": [
                {
                  "@type": "Person",
                  "name": "Junaid Khan",
                  "jobTitle": "Developer",
                  "sameAs": "https://www.linkedin.com/in/junaidkhan"
                }
              ]
            }
          `}
        </script>
        <script type="application/ld+json">{breadcrumbSchemaJson([{ name: "Team", path: "/team" }])}</script>
      </Helmet>
     
      <div className="d-flex justify-content-center">
        <div className="hr_line_black" />
      </div>
      <div className="row m-0 p-0">
        <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
        <div className="col-lg-8 col-md-10 col-sm-12 col-12">
          <h1 className="new_opening_para">Meet the Experts Powering 360 SynergyTech</h1>
          <div className="spacer"></div> {/* Added spacer for vertical space */}
          <h2 className="new_opening_heading">Skilled Developers, AI Specialists, Cloud Architects & More</h2>
          {/* Featured Team Members (First 2 - Large) */}
          <div className="row p-0 m-0 featured-members" style={{ marginBottom: '20px' }}> {/* Added margin-bottom for space between images */}
            {featuredMembers.map((member) => (
              <div key={member.id} className="col-lg-6 col-md-6 col-sm-12 col-12">
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/images/${member.photo}`}
                  alt={member.name}
                  className="team_member_pic_b"
                  width="500"
                  height="420"
                  loading="lazy"
                />
                <div className="description_team_member_b">
                  <h3 className="name_member_b">{member.name}</h3>
                  <h4 className="desp_member_b">{member.role}</h4>
                </div>
              </div>
            ))}
          </div>

          {/* Regular Team Members (Rest - Small) */}
          {regularMembers.length > 0 && (
            <div className="row p-0 m-0 regular-members justify-content-center" style={{ marginBottom: '20px' }}> {/* Added margin-bottom for space between images */}
              {regularMembers.map((member) => (
                <div key={member.id} className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/images/${member.photo}`}
                    alt={member.name}
                    className="team_member_s_pic"
                    width="200"
                    height="194"
                    loading="lazy"
                  />
                  <div className="description_team_member_s">
                    <h3 className="name_member_s">{member.name}</h3>
                    <h4 className="desp_member_s">{member.role}</h4>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="col-lg-2 col-md-1 col-sm-12 col-12"></div>
      </div>
    </div>
  )
}

export default TeamMembers